import React from 'react'

export default () => (
  <div id="root" style={{height: '100vh'}} className="flex">
    <div id="fuse-splash-screen">
      <div className="center">
        <div className="logo">
          <img
            width="128"
            src="assets/images/logos/deeple_light.png"
            alt="logo"
          />
        </div>

        <div className="spinner-wrapper">
          <div className="spinner">
            <div className="inner">
              <div className="gap" />
              <div className="left">
                <div className="half-circle" />
              </div>
              <div className="right">
                <div className="half-circle" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/auth/AuthLoadingScreen.js